import { render, staticRenderFns } from "./device-activation.vue?vue&type=template&id=4b012408&scoped=true"
import script from "./device-activation.vue?vue&type=script&lang=js"
export * from "./device-activation.vue?vue&type=script&lang=js"
import style0 from "./device-activation.vue?vue&type=style&index=0&id=4b012408&lang=scss&scoped=true"
import style1 from "./device-activation.vue?vue&type=style&index=1&id=4b012408&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b012408",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b012408')) {
      api.createRecord('4b012408', component.options)
    } else {
      api.reload('4b012408', component.options)
    }
    module.hot.accept("./device-activation.vue?vue&type=template&id=4b012408&scoped=true", function () {
      api.rerender('4b012408', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/data-service/device-data/device-activation.vue"
export default component.exports